export const aboutData = {
  section: 'About',
  items: [
    {
      title: 'Templates',
      value:
        'Website templates are pre-designed code structures that developers can use to quickly build websites.',
      link: '/infobook/html',
      linkHelper: 'About',
    },
    {
      title: 'Free Templates',
      value:
        "At TechTutz, we offer some templates for free to support developers, promote best practices in web development, and help small businesses get started online. It's also a way for us to give back to the community and demonstrate the value we provide through practical, high-quality resources.",
      link: '/infobook/html',
      linkHelper: 'About',
    },
    {
      title: 'Premium Templates',
      value:
        "Our paid templates offer more complex features, polished design, and higher-quality code, making them ideal for businesses or developers who need professional-grade solutions with advanced functionality.",
      link: '/infobook/html',
      linkHelper: 'About',
    },
  ],
};
